import { AuditWrapper } from '../../../components/hub/AuditWrapper';
import { StoragePage } from '../../StoragePage';

export function HubStoragePage() {
  return (
    <AuditWrapper>
      <StoragePage />
    </AuditWrapper>
  );
}
